import {CustomerSpecialPrice} from "./customer-special-price";

export class CustomerSpecialPriceResponse {
  VerrechnungsPreiscodeKunde: string;
  SonderpreiseKunde: CustomerSpecialPrice[];
}
